import {AfterViewInit, Directive, ElementRef, inject} from '@angular/core';
import {DomPortal} from '@angular/cdk/portal';

@Directive({
    selector: '[appTableFilterPortal]',
    exportAs: 'filterPortal'
})
export class TableFilterPortalDirective implements AfterViewInit {
    /** Dom элемент контейнера таблицы */
    readonly #elementRef: ElementRef<HTMLElement> = inject(ElementRef);

    /** Объект портала */
    public portal: DomPortal = null;

    public ngAfterViewInit(): void {
        const filter = this.#elementRef.nativeElement?.querySelector('.table-filter-container') as HTMLElement;
        if (filter) {
            // Помещаем в очередь макро задач присвоение свойства
            setTimeout(() => {
                this.portal = new DomPortal(filter);
            });
        }


    }
}
